import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { useIsAdminUser } from 'components/user/UserProvider';
import Lesson from 'models/Lesson';
import React from 'react';
import LessonCard from './components/LessonCard/LessonCard';
import LessonProvider from './components/LessonProvider';

interface Props {
  lessons: Lesson[];
}

const useStyles = makeStyles((theme) => ({
  cardWrapper: {
    '& + $cardWrapper': {
      marginTop: 20,
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 15,
  },
}));

const ResourceCards: React.FC<Props> = ({ lessons }) => {
  const classes = useStyles();
  const isAdminUser = useIsAdminUser();

  let lessonsForDisplay: Lesson[];

  if (isAdminUser) {
    lessonsForDisplay = lessons;
  } else {
    lessonsForDisplay = lessons.filter(lesson => lesson.submissionApproved === true);
  }

  return (
    <div>
      {lessons === null ? (
        <CircularProgress />
      ) : (
        <>
          {lessonsForDisplay.map((lesson, index) => (
            <div className={classes.cardWrapper} key={index}>
              <LessonProvider lesson={lesson}>
                <LessonCard />
              </LessonProvider>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default ResourceCards;
